import { CFC } from "@api/types/cypress";
import { Enrollment } from "@api/types/enrollments";
import React, { Fragment } from "react";

import EnrolledCourse from "@components/EnrolledCourse";
import Spacer from "@components/Spacer";

const EnrolledCourses: CFC<{ enrollments: Enrollment[] }> = ({ enrollments }) => {
  return (
    <>
      {enrollments.length === 0 && (
        <p>
          You are not currently enrolled in any courses. Please visit the Course Catalog to purchase/enroll in
          a course.
        </p>
      )}
      {enrollments.map((c) => {
        return (
          <Fragment key={c.id}>
            <EnrolledCourse enrollment={c} />
            <Spacer size={"md"} />
          </Fragment>
        );
      })}
    </>
  );
};

export default EnrolledCourses;
